module.exports = __webpack_public_path__ + "img/academic_degree.89bc98a5.svg";